<div class="container single-view" id="add-business-group">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/business-groups/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'BUSINESS_GROUPS.BTN_BACK_TO_BUSINESS_GROUP' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-businessgroup-title" class="section-title">{{ 'BUSINESS_GROUP_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-businessgroup-subtitle" class="section-subtitle mt-1 text-base">{{ 'BUSINESS_GROUP_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="businessGroupForm" data-testid="add-businessgroup-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">{{ 'BUSINESS_GROUP_CREATE.BUSINESS_GROUP_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-businessgroup-field-name" class="block text-sm" for="name">{{ 'BUSINESS_GROUP_CREATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-businessgroup-name-input" type="text" id="name" formControlName="name" autocomplete="off">
                  @if (businessGroupForm.get('name')?.invalid && businessGroupForm.get('name')?.touched) {
                    <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label  data-testid="add-businessgroup-field-code" class="block text-sm" for="code">{{ 'BUSINESS_GROUP_CREATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-businessgroup-code-input" type="text" id="code" formControlName="code" autocomplete="off">
                  @if (businessGroupForm.get('code')?.invalid && businessGroupForm.get('code')?.touched) {
                    <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-businessgroup-create-businessgroup-button" class="btn primary-btn" [disabled]="businessGroupForm.invalid"
                      (click)="submitForm()">{{
                    'BUSINESS_GROUP_CREATE.BTN_CREATE_BUSINESS_GROUP' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
